import { Component, OnInit } from '@angular/core';
import { SurveyFormFields } from '../../core/models/survey-form/form-fields';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-survey-form',
    templateUrl: './survey-form.component.html',
    styleUrls: ['./survey-form.component.scss'],
    standalone: false
})
export class SurveyFormComponent implements OnInit {
  form: UntypedFormGroup;
  showFormError: boolean = false;
  surveyFormFields: SurveyFormFields;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly modal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.formBuilder.group({
      reason: ['', Validators.required],
      otherReason: [''],
    });
  }

  handleValueChange(value: string) {
    const otherReason = this.form.get('otherReason');

    if (value === 'Other') {
      otherReason.setValidators([Validators.required]);
    } else {
      otherReason.clearValidators();
      otherReason.setValue('');
    }

    otherReason.updateValueAndValidity();
  }

  close() {
    this.modal.dismiss();
  }

  submit() {
    this.showFormError = false;

    if (this.form.invalid) {
      this.showFormError = true;
      return;
    }

    this.modal.close({
      reason: this.form.get('reason').value,
      otherReason: this.form.get('otherReason').value,
    });
  }
}
